// extracted by mini-css-extract-plugin
export default {"component":"style--component--92d96b"};